import { IConfig } from '@cian/config/shared';

import { checkNewExperiment } from '../../../../shared/utils/experiments/checkNewExperiment';
import { NEXT_AGREEMENT_FLOW_EXPERIMENT } from '../../../../shared/constants/config/experiments';
import { IExperiment } from '../../../../shared/types/experiments';

interface IDependencies {
  config: IConfig;
}

export function isNextAgreementFlow({ config }: IDependencies, experiments: IExperiment[]): boolean {
  const isNextAgreementFlowEnabled = config.get<boolean>('auth.nextAgreementFlow.enabled');

  return (
    (isNextAgreementFlowEnabled != null ? isNextAgreementFlowEnabled : true) &&
    checkNewExperiment(experiments, NEXT_AGREEMENT_FLOW_EXPERIMENT, 'B')
  );
}
